/** FAB feature keys — add members when a flag is wired in the widget. */
export enum GrowthBookFeatureKey {}

/**
 * Declarative check against a single GrowthBook feature flag.
 * `expected` defaults to `true` (i.e. the flag must be ON).
 * Set `expected: false` to require the flag to be OFF
 * (handy for "the legacy version of …" branches).
 */
export interface GrowthBookFeatureCheck {
  key: GrowthBookFeatureKey;
  expected?: boolean;
}

export type GrowthBookFeatures = Record<string, unknown>;

export interface GrowthBookProfile {
  id: number;
  email: string;
  gender: string;
  age: string;
  birthday: string;
  startDate: string;
  location: string;
  businessUnit: string;
  service: string;
  team: string;
  function: string;
  position: string;
  status: string;
  seniority: string;
  workFormat: string;
}

export interface GrowthBookAttributes {
  id: number;
  email: string;
  gender: string;
  age: string;
  birthday: string;
  startDate: string;
  location: string;
  businessUnit: string;
  service: string;
  team: string;
  function: string;
  position: string;
  status: string;
  seniority: string;
  workFormat: string;
  deviceType: string;
  osName: string;
  gbTest?: string;
  experiments?: string[];
}
